import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  dialogHeaderStyle: {
    borderBottom: 'none',
    paddingBottom: 16,
  },
  dialogContentStyle: {
    '&.MuiDialogContent-root': {
      paddingTop: 0,
    },
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  toggleWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: 16,
  },
}));

export default useStyles;
